<ng-container *ngIf="service?.category" [ngSwitch]="service?.category">
  <fin-included-product-item-summary-seat
    *ngSwitchCase="Category.SEAT"
    [bodyClass]="bodyClass"
    [passengers]="passengers"
    [bound]="bound"
    [service]="service"
    [showPendingServicesInTitles]="showPendingServicesInTitles"
  ></fin-included-product-item-summary-seat>
  <fin-included-product-item-summary-other *ngSwitchDefault [summary]="serviceSummary" [bodyClass]="bodyClass">
  </fin-included-product-item-summary-other>
</ng-container>
